import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const advantages = [
  {
    icon: 'ri-shield-check-line',
    key: 'quality',
  },
  {
    icon: 'ri-price-tag-3-line',
    key: 'price',
  },
  {
    icon: 'ri-calendar-check-line',
    key: 'convenient',
  },
  {
    icon: 'ri-customer-service-2-line',
    key: 'guarantee',
  },
];

export default function WhyUs() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            {t('whyUs.title')}
          </h2>
          <p className="text-sm text-foreground-500">
            {t('whyUs.subtitle')}
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {advantages.map((adv) => (
            <div key={adv.key} className="text-center p-6">
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100">
                <i className={`${adv.icon} text-2xl text-accent-500`}></i>
              </div>
              <h3 className="font-semibold text-foreground-900 text-sm mb-2 whitespace-nowrap">
                {t(`whyUs.${adv.key}`)}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {t(`whyUs.${adv.key}Desc`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}